export const SET_DATA = "manageaccount/SET_DATA";
export const RESET = "manageaccount/RESET";
